enum Types {
  GET_DASHBOARD_DATA_REQUEST = 'GET_DASHBOARD_DATA_REQUEST',
  GET_DASHBOARD_DATA_FULFILLED = 'GET_DASHBOARD_DATA_FULFILLED',
  GET_DASHBOARD_DATA_REJECTED = 'GET_DASHBOARD_DATA_REJECTED',

  GET_DASHBOARD_DATA_PARTNER_REQUEST = 'GET_DASHBOARD_DATA_PARTNER_REQUEST',
  GET_DASHBOARD_DATA_PARTNER_FULFILLED = 'GET_DASHBOARD_DATA_PARTNER_FULFILLED',
  GET_DASHBOARD_DATA_PARTNER_REJECTED = 'GET_DASHBOARD_DATA_PARTNER_REJECTED',

  GET_INCIDENT_PANEL_DATA_REQUEST = 'GET_INCIDENT_PANEL_DATA_REQUEST',
  GET_INCIDENT_PANEL_DATA_FULFILLED = 'GET_INCIDENT_PANEL_DATA_FULFILLED',
  GET_INCIDENT_PANEL_DATA_REJECTED = 'GET_INCIDENT_PANEL_DATA_REJECTED',

  GET_PARTNER_DATA_GRAPH_REQUEST = 'GET_PARTNER_DATA_GRAPH_REQUEST',
  GET_PARTNER_DATA_GRAPH_FULFILLED = 'GET_PARTNER_DATA_GRAPH_FULFILLED',
  GET_PARTNER_DATA_GRAPH_REJECTED = 'GET_PARTNER_DATA_GRAPH_REJECTED',

  SET_PARTNER_DATA_PERIOD_FILTER = 'SET_PARTNER_DATA_PERIOD_FILTER',

  SET_PARTNER_DATA_PERIOD_CARD_FILTER = 'SET_PARTNER_DATA_PERIOD_CARD_FILTER',

  GET_DATA_DASHBOARD_HISTORY_REQUEST = 'GET_DATA_DASHBOARD_HISTORY_REQUEST',
  GET_DATA_DASHBOARD_HISTORY_FULFILLED = 'GET_DATA_DASHBOARD_HISTORY_FULFILLED',
  GET_DATA_DASHBOARD_HISTORY_REJECTED = 'GET_DATA_DASHBOARD_HISTORY_REJECTED',

  GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REQUEST = 'GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REQUEST',
  GET_PARTNER_ENVIRONMENTS_COST_GRAPH_FULFILLED = 'GET_PARTNER_ENVIRONMENTS_COST_GRAPH_FULFILLED',
  GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REJECTED = 'GET_PARTNER_ENVIRONMENTS_COST_GRAPH_REJECTED',
  SET_PARTNER_ENVIRONMENTS_COST_PERIOD_FILTER = 'SET_PARTNER_ENVIRONMENTS_COST_PERIOD_FILTER',
}

export default Types;
